import { render } from "./HeadHome.vue?vue&type=template&id=0ae24a6c"
import script from "./HeadHome.vue?vue&type=script&lang=js"
export * from "./HeadHome.vue?vue&type=script&lang=js"

import "./HeadHome.vue?vue&type=style&index=0&id=0ae24a6c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__